<template lang="pug">
v-container#package-tables(fluid, tag="div")
  h3 Package List
  v-btn.mb-3(color="#03B3EB", @click="toggleAdd") Add New Package
  v-dialog(data-app, v-model="add", persistent, max-width="600px")
    v-card
      v-card-title
        span.headline Add Package
      v-card-text
        v-form(ref="form", v-model="valid", lazy-validation)
          v-text-field.mb-2(
            v-model="packageName",
            :rules="nameRules",
            label="Package Name",
            required
          )
          v-text-field.mb-2(
            type="number",
            v-model="packagePrice",
            :rules="numberRules",
            label="Package Price",
            required
          )
          v-text-field.mb-2(
            type="number",
            v-model="packageBalance",
            :rules="numberRules",
            label="Package Balance",
            required
          )
          v-textarea.mb-2(
            v-model="packageDescription",
            label="Package Description"
          )
          v-text-field.mb-2(
            type="number",
            v-model="packageValid",
            :rules="numberRules",
            label="Package Validity(days)",
            required
          )
          v-select.mb-2(
            data-app,
            v-model="packageType",
            :items="type_list",
            item-text="type_name",
            item-value="type_id",
            :rules="[(v) => !!v || 'Type is required']",
            label="Type",
            required
          )
          v-select.mb-2(
            data-app,
            v-model="packageStatus",
            :items="status_list",
            item-text="status_name",
            item-value="status_id",
            :rules="[(v) => !!v || 'Status is required']",
            label="Status",
            required
          )
      v-card-actions
        v-btn(color="#FD0101", text, @click="closeAdd") Cancel
        v-btn(color="#03B3EB", text, @click="submit") Submit
        v-btn(color="#2DC64F", text, @click="reset") Reset
  v-card
    v-card-title
      v-text-field.my-2(
        v-model="search",
        append-icon="mdi-magnify",
        label="Search",
        single-line,
        hide-details
      )
    v-data-table(
      :headers="package_headers",
      :items="package_list",
      :search="search"
    )
      template(v-slot:item.type="{ item }")
        td {{ item.type == "1" ? 'Individual' : item.type == "2" ? 'Corporate' : 'N/A' }}
      template(v-slot:item.status="{ item }")
        td {{ parseInt(item.status) ? 'ACTIVE' : 'SUSPENDED' }}
      template(v-slot:item.created_at="{ item }")
        td {{ $moment(parseInt(item.created_at)).format("DD MMM YYYY hh:mm a") }}
      template(v-slot:item.updated_at="{ item }")
        td {{ $moment(parseInt(item.updated_at)).format("DD MMM YYYY hh:mm a") }}
      template(v-slot:item.actions="{ item }")
        td.d-flex.flex-row
          v-icon.mr-2(small, color="#FD0101", @click="goto(item)") mdi-tools
          v-icon.mr-2(small, color="warning", @click="assign(item)") mdi-account-plus
          v-icon.mr-2(small, color="#03B3EB", @click="editPackage(item)") mdi-pencil
          v-icon(small, color="#2DC64F", @click="deletePackage(item)") mdi-delete
  v-dialog(data-app, v-model="dialog", persistent, max-width="600px")
    v-card
      v-card-title
        span.headline Edit Package
      v-card-text
        v-form.p-4(ref="edit", v-model="valid", lazy-validation)
          v-text-field.mb-2(
            readonly
            disabled
            v-model="editedItem.id",
            label="Package ID",
            required
          )
          v-text-field.mb-2(
            v-model="editedItem.package_name",
            :rules="nameRules",
            label="Package Name",
            required
          )
          v-text-field.mb-2(
            type="number",
            v-model="editedItem.pricing",
            :rules="numberRules",
            label="Package Price",
            required
          )
          v-text-field.mb-2(
            type="number",
            v-model="editedItem.available_balance",
            :rules="numberRules",
            label="Package Balance",
            required
          )
          v-textarea.mb-2(
            v-model="editedItem.description",
            label="Package Description"
          )
          v-text-field.mb-2(
            type="number",
            v-model="editedItem.valid_period",
            :rules="numberRules",
            label="Package Validity(days)",
            required
          )
          v-select.mb-2(
            data-app,
            v-model="editedItem.type",
            :items="type_list",
            item-text="type_name",
            item-value="type_id",
            :rules="[(v) => !!v || 'Type is required']",
            label="Type",
            required
          )
          v-select.mb-2(
            data-app,
            v-model="editedItem.status",
            :items="status_list",
            item-text="status_name",
            item-value="status_id",
            :rules="[(v) => !!v || 'Status is required']",
            label="Status",
            required
          )
      v-card-actions
        v-spacer
        v-btn(color="blue darken-1", text, @click="close") Cancel
        v-btn(color="blue darken-1", text, @click="save") Save
  v-dialog(data-app, v-model="dialogAssign", persistent, max-width="600px")
    v-card
      v-card-title
        span.headline Assign Package
      v-card-text
        v-form.p-4(ref="assign", v-model="valid", lazy-validation)
          v-text-field.mb-2(
            readonly
            disabled
            v-model="editedItem.id",
            label="Package ID",
            required
          )
          v-text-field.mb-2(
            readonly
            v-model="editedItem.package_name",
            :rules="nameRules",
            label="Package Name",
            required
          )
          v-text-field.mb-2(
            readonly
            type="number",
            v-model="editedItem.pricing",
            :rules="numberRules",
            label="Package Price",
            required
          )
          v-text-field.mb-2(
            readonly
            type="number",
            v-model="editedItem.available_balance",
            :rules="numberRules",
            label="Package Balance",
            required
          )
          v-textarea.mb-2(
            readonly
            v-model="editedItem.description",
            label="Package Description"
          )
          v-text-field.mb-2(
            readonly
            type="number",
            v-model="editedItem.valid_period",
            :rules="numberRules",
            label="Package Validity(days)",
            required
          )
          v-select.mb-2(
            readonly
            data-app,
            v-model="editedItem.type",
            :items="type_list",
            item-text="type_name",
            item-value="type_id",
            :rules="[(v) => !!v || 'Type is required']",
            label="Type",
            required
          )
          v-text-field.mb-2(
            type="number",
            v-model="assignUserId",
            :rules="numberRules",
            label="Assigned User ID",
            required
          )
      v-card-actions
        v-spacer
        v-btn(color="blue darken-1", text, @click="closeAssign") Cancel
        v-btn(color="blue darken-1", text, @click="goAssign") Save
  v-dialog(data-app, persistent, v-model="dialogDelete", max-width="600px")
    v-card
      v-card-title.headline Are you sure you want to delete <br> {{ editedItem.package_name }} package?
      v-card-actions
        v-spacer
        v-btn(color="blue darken-1", text, @click="closeDelete") Cancel
        v-btn(color="blue darken-1", text, @click="deletePackageConfirm") OK
        v-spacer
</template>

<script>
export default {
  name: "Package",
  data() {
    return {
      search: "",
      add: false,
      dialog: false,
      dialogDelete: false,
      dialogAssign: false,
      editedIndex: -1,
      editedItem: {},
      package_list: [],
      package_headers: [
        { text: "Actions", value: "actions" },
        { text: "#", value: "id", cellClass: "font-weight-bold" },
        { text: "Name", value: "package_name" },
        { text: "Price", value: "pricing" },
        { text: "Balance", value: "available_balance" },
        { text: "Desc", value: "description" },
        { text: "Type", value: "type" },
        { text: "Validity(days)", value: "valid_period" },
        { text: "C.By", value: "created_by" },
        { text: "C.Dt", value: "created_at" },
        { text: "M.By", value: "updated_by" },
        { text: "M.Dt", value: "updated_at" },
        { text: "Status", value: "status" },
      ],
      type_list: [
        {
          type_id: "1",
          type_name: "Individual",
        },
        {
          type_id: "2",
          type_name: "Corporate",
        },
      ],
      status_list: [
        {
          status_id: "0",
          status_name: "Suspended",
        },
        {
          status_id: "1",
          status_name: "Active",
        },
      ],
      packageName: "",
      packagePrice: 0,
      packageBalance: 0,
      packageDescription: "",
      packageType: "1",
      packageValid: 0,
      packageStatus: "0",
      assignUserId: null,
      nameRules: [(v) => !!v || "Name is required"],
      numberRules: [
        (v) => !!v || "Required",
        (v) => parseFloat(v) > 0 || "Cannot be negative",
      ],
      valid: true,
      loading: false,
    };
  },
  mounted() {
    $("#addPackage").hide();
    this.getPackageList();
  },
  methods: {
    goto(item) {
      this.$router.push("/portal/admin/service?id=" + item.id);
    },
    submit() {
      if (!this.$refs.form.validate()) return;

      const url = "https://saas-api.xendity.com/v1/admin/add-package";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
        package_name: this.packageName,
        pricing: this.packagePrice,
        available_balance: this.packageBalance,
        description: this.packageDescription,
        type: this.packageType,
        valid_period: this.packageValid,
        status: this.packageStatus,
        created_by: this.$store.getters.userId,
        created_at: new Date().getTime(),
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function (response) {
          // Success
          try {
            if (response) {
              this.loading = false;
              if (response.body.success == false)
                this.$swal(
                  "Create package error",
                  response.body.data.message,
                  "error"
                );
              else {
                this.$swal("Create package successful!", "Success", "success");
                this.closeAdd();
                this.getPackageList();
              }
            }
          } catch (error) {
            this.$swal("Create package error", response.body.data.message, "error");
          }
        })
        .catch((response) => {
          this.$swal("Create package error", response.body.data.message, "error");
        });
    },
    reset() {
      this.$refs.form.reset();
    },
    toggleAdd() {
      this.add = true;
    },
    editPackage(item) {
      this.editedIndex = this.package_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    assign(item) {
      this.editedIndex = this.package_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogAssign = true;
    },
    deletePackage(item) {
      this.editedIndex = this.package_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    save() {
      if (!this.$refs.edit.validate()) return;

      const url = "https://saas-api.xendity.com/v1/admin/update-package";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
        package_id: this.editedItem.id, 
        package_name: this.editedItem.package_name, 
        pricing: this.editedItem.pricing, 
        available_balance: this.editedItem.available_balance, 
        description: this.editedItem.description, 
        type: this.editedItem.type, 
        valid_period: this.editedItem.valid_period, 
        status: this.editedItem.status, 
        updated_by: this.$store.getters.userId,
        updated_at: new Date().getTime(),
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function (response) {
          // Success
          try {
            if (response) {
              this.loading = false;
              if (response.body.success == false)
                this.$swal(
                  "Update package error",
                  response.body.data.message,
                  "error"
                );
              else {
                this.$swal("Update package successful!", "Success", "success");
                this.close();
                this.getPackageList();
              }
            }
          } catch (error) {
            this.$swal("Update package error", response.body.data.message, "error");
          }
        })
        .catch((response) => {
          this.$swal("Update package error", response.body.data.message, "error");
        });
    },
    goAssign() {
      if (!this.$refs.assign.validate()) return;

      const url = "https://saas-api.xendity.com/v1/admin/assign-package";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
        package_id: this.editedItem.id, 
        user_id: this.assignUserId
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function (response) {
          // Success
          try {
            if (response) {
              this.loading = false;
              if (response.body.success == false)
                this.$swal(
                  "Assign package error",
                  response.body.data.message,
                  "error"
                );
              else {
                this.$swal("Assign package successful!", "Success", "success");
                this.closeAssign();
              }
            }
          } catch (error) {
            this.$swal("Assign package error", response.body.data.message, "error");
          }
        })
        .catch((response) => {
          this.$swal("Assign package error", response.body.data.message, "error");
        });
    },
    deletePackageConfirm() {
      const url = "https://saas-api.xendity.com/v1/admin/delete-package";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
        package_id: this.editedItem.id
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function (response) {
          // Success
          try {
            if (response) {
              this.loading = false;
              if (response.body.success == false)
                this.$swal(
                  "Delete package error",
                  response.body.data.message,
                  "error"
                );
              else {
                this.$swal("Delete package successful!", "Success", "success");
                this.closeDelete();
                this.getPackageList();
              }
            }
          } catch (error) {
            this.$swal("Delete package error", response.body.data.message, "error");
          }
        })
        .catch((response) => {
          this.$swal("Delete package error", response.body.data.message, "error");
        });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
    closeAssign() {
      this.dialogAssign = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
    closeAdd() {
      this.add = false;
      this.reset();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
    getPackageList() {
      const url = "https://saas-api.xendity.com/v1/admin/package-list";

      const json = {
        username: this.$store.getters.userName,
        auth_key: this.$store.getters.authKey,
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then((response) => {
          // Success
          try {
            if (response) {
              if (response.body.success == false)
                this.$swal(
                  "Get admin package list failed",
                  response.body.data.message,
                  "error"
                );
              else this.package_list = response.body.data.package_list;
            }
          } catch (error) {
            this.$swal(
              "Get admin package list failed",
              response.body.data.message,
              "error"
            );
          }
        })
        .catch((response) => {
          this.$swal(
            "Get admin package list failed",
            response.body.data.message,
            "error"
          );
        });
    },
  },
};
</script>